
import { Component, Vue } from "vue-property-decorator";
import begdetail from "@/template/house/begDetail.vue";
@Component
export default class begDetail extends begdetail {
  mounted() {}
}
